import { ReactNode, createContext, useMemo, useState } from 'react';
import { CardPaginationFilter } from '@shared/api/providers/cardPagination';

export interface CardActionsState {
  active: boolean;
  setActive(active: boolean): void;
}

export interface CardFilterState {
  appliedFilters: CardPaginationFilter[];
  setAppliedFilters(filters: CardPaginationFilter[]): void;
  excludedFieldNames: string[];
  setExcludedFieldNames(fieldNames: string[]): void;
}

const defaultCardActionsState: CardActionsState = {
  active: false,
  setActive: () => {},
};

const defaultCardFilterState: CardFilterState = {
  appliedFilters: [],
  setAppliedFilters: () => {},
  excludedFieldNames: [],
  setExcludedFieldNames: () => {},
};

export const CardActionsStateContext = createContext<CardActionsState>(defaultCardActionsState);
export const CardFilterStateContext = createContext<CardFilterState>(defaultCardFilterState);

interface Props {
  children: ReactNode;
}

export function MBCardActionsProvider({ children }: Props) {
  const [appliedFilters, setAppliedFilters] = useState<CardPaginationFilter[]>([]);
  const [excludedFieldNames, setExcludedFieldNames] = useState<string[]>([]);

  const value = useMemo<CardFilterState>(
    () => ({
      appliedFilters,
      setAppliedFilters,
      excludedFieldNames,
      setExcludedFieldNames,
    }),
    [appliedFilters, excludedFieldNames],
  );

  const [active, setActive] = useState<boolean>(false);
  const actionState = useMemo<CardActionsState>(() => ({ active, setActive }), [active, setActive]);

  return (
    <CardActionsStateContext.Provider value={actionState}>
      <CardFilterStateContext.Provider value={value}>{children}</CardFilterStateContext.Provider>
    </CardActionsStateContext.Provider>
  );
}
